// extracted by mini-css-extract-plugin
module.exports = {"content":"latestNewsStyle-module--content--3bTED","calloutHighlightHeader":"latestNewsStyle-module--calloutHighlightHeader--2nLvp","slide":"latestNewsStyle-module--slide--1E8LE"};